// all colors come from our Bronte design system: https://www.figma.com/file/gzfeDnviI7jUPFnn8tdzU7/Bronte-Design-System?node-id=944%3A356
export const bronteColors = {
  black: "#000000",
  bondiMint: "#B2FCE4", // primary
  bondiMintDisabled: "#D8FDF1",
  bondiMintFocus: "#7FFAD2",
  bondiMintPress: "#4EF8C1",
  disabledButton: "#808080",
  green: "#80D187", // checkmark icon
  green50: "#0E9755", // not sure if this is green50 but its used as success text
  orca: "#3375C9", // tertiary
  orcaPastel: "#EFF4FB",
  plum: "#EADDF2", // secondary
  gray10: "#1A1A1A",
  gray20: "#333333",
  gray30: "#4D4D4D", // secondary text
  gray40: "#666666",
  gray50: "#808080",
  gray60: "#999999",
  gray70: "#B2B2B2",
  gray80: "#CCCCCC",
  gray90: "#E5E5E5",
  gray96: "#F5F5F5",
  red: "#CC3300", // errors
  white: "#FFFFFF",
  yellow: "#FFB600",
};
